import React from 'react'
import styled from 'styled-components'
import Button from '../../components/Button'

const ClearFix = styled.div`clear: both;`
const TaggingImage = styled.img`
  width: 40%;
  float: left;
`
const TaggingContent = styled.div`
  display: inline-block;
  box-sizing: border-box;
  width: 60%;
  padding-left: 0.5em;
`
const Textarea = styled.textarea`width: 100%;`

const TagImagesScreen = ({
  images,
  currentImageIndex,
  handleChangeImageDescription,
  handleChangeImageTags,
  handleImageUpload,
  goToNextImage,
}) => {
  const image = images[currentImageIndex]
  const shouldUpload = images.length - 1 === currentImageIndex
  return (
    <div>
      <h3>Name and Tag Images</h3>
      <div>
        <TaggingImage src={image.file.preview} alt="" />
        <TaggingContent>
          <p>Description</p>
          <Textarea
            rows="4"
            onChange={handleChangeImageDescription}
            value={image.description}
          />
          <p>Tags</p>
          <Textarea
            rows="4"
            onChange={handleChangeImageTags}
            value={image.tags.join(', ')}
          />
        </TaggingContent>
      </div>
      <ClearFix />
      <p>Note: Separate each tag with a comma and a space.</p>
      {shouldUpload ? (
        <Button
          raised
          primary
          onClick={handleImageUpload}
          style={{ display: 'block', marginLeft: 'auto' }}>
          Upload
        </Button>
      ) : (
        <Button
          onClick={goToNextImage}
          style={{ display: 'block', marginLeft: 'auto' }}>
          Next
        </Button>
      )}
    </div>
  )
}

export default TagImagesScreen



// WEBPACK FOOTER //
// ./src/components/ImageSelectionModal/TagImagesScreen.js